// @ts-check
import Product from './typePolicies.Product';

/**
 * @param {{ productId: string; __typename: string }} value
 * @param {{ fieldname: string; toReference: Parameters<import('@apollo/client/cache').FieldReadFunction>[1]["toReference"]; readField: Parameters<import('@apollo/client/cache').FieldReadFunction>[1]["readField"] }} value
 */
function tryRef(value, { fieldname, toReference, readField }) {
  const ref = toReference(value);
  if (readField(fieldname, ref)) return ref;
}

/** @type {import('../generated/clientHelpers').StrictTypedTypePolicies} */
const typePolicies = {
  Activity: { keyFields: ['activityId'] },
  Beer: Product,
  Brand: {
    keyFields: ['brandId'],
    fields: {
      // Make sure that all image sizes are available on the cache.
      logo: { merge: true },
      products: {},
      product: {
        // @ts-ignore
        read(current, { args: { productId }, toReference, readField }) {
          if (current) return current;
          const options = { fieldname: 'productId', toReference, readField };
          // Try to read different types of products.
          return (
            tryRef({ __typename: 'Wine', productId }, options) ||
            tryRef({ __typename: 'Beer', productId }, options) ||
            tryRef({ __typename: 'Spirit', productId }, options) ||
            tryRef({ __typename: 'Cider', productId }, options) ||
            tryRef({ __typename: 'Other', productId }, options)
          );
        },
      },
    },
  },
  Collection: {
    keyFields: ['collectionId'],
  },
  DataImport: { keyFields: ['importId'], fields: { source: { merge: true } } },
  Event: { keyFields: ['eventId'] },
  ELabel: { keyFields: ['elabelId', 'versionId'] },
  ELabelVersion: { keyFields: ['versionId'] },
  Exhibitor: { keyFields: ['exhibitorId'] },
  ExportConfiguration: { keyFields: ['configurationId'] },
  Message: { keyFields: ['messageId'] },
  Partner: { keyFields: ['partnerId'] },
  Producer: { keyFields: ['producerId'] },
  Product,
  ProductConnection: {},
  ProductList: {
    keyFields: ['productListId'],
    fields: {
      products: { merge: true },
    },
  },
  Query: {
    fields: {
      currentUser: { merge: true },
    },
  },
  Registration: {
    keyFields: ['registrationId'],
  },
  RegisteredProduct: {
    keyFields: ['productId'],
  },
  ShareList: {
    keyFields: ['shareListId'],
    fields: {
      products: { merge: true },
    },
  },
  Spirit: Product,
  Wine: Product,
  Workspace: {
    keyFields: ['workspaceId'],
  },
};

export default typePolicies;
